import React, {useState, useEffect, useContext} from 'react';
import {useHistory} from "react-router-dom";
import NavBar from "./Navbar";
import {Button} from "../layout/Form";
import UserContext from "../../context/user/UserContext";
import useSize from "../../hooks/useSize";
import firebase from "../../firebase";

const Header = () => {

    const history = useHistory();
    const [change, setChange] = useState(true);

    const {logout} = useContext(UserContext);

    const size = useSize();
    const menu = document.getElementById("menu");
    const icon = document.getElementById("icon");

    const handleMenu = () => {
        if(change){
            icon.classList.remove("fas", "fa-bars");
            icon.classList.add("fas", "fa-times");
            menu.style.display = "block";
            setChange(false);
        }
        else{
            icon.classList.remove("fas", "fa-times");
            icon.classList.add("fas", "fa-bars");
            menu.style.display = "none";
            setChange(true);
        }
    }

    const handleLogout = async () => {
        await firebase.signOut();
        logout();
        history.replace("/login");
    }

    useEffect(() => {
        if(size.width > 720){
            menu.style.display = "flex";
        }
        if(size.width <= 720){
            menu.style.display = "none";
        }
    }, [size]);
    
    return (
        <header className = "header bg-white">
            <div className="container">
                <div className="icon-container">
                    <div className="icon-content">
                        <h1 className = "ml-5">Icon</h1>
                        <i className ="fas fa-bars icon" onClick = {handleMenu} id = "icon"></i>
                    </div>
                </div>
                <div className="flex-around" id = "menu">
                    <NavBar />
                    <Button onClick = {handleLogout} className = "btn-responsive">Cerrar Sesión</Button>
                </div>
            </div>

        </header>

    );
}
 
export default Header;